import React, { useMemo, useState } from 'react';
import { toast } from '@cashfree-intl/coherent';

// Services
import { getActive2FAMethod, send2FAOtp, validate2FA, verify2FAOtp } from 'services/twoFa';

// Context
import { TwoFAContext } from 'contexts/TwoFAContext';

//Types
import { Callbacks } from 'contexts/types';


const TwoFAProvider = ({ children }: { children: React.ReactNode }) => {
  const [modeActive, setModeActive] = useState('');
  const [is2FAVerified, setIs2FAVerified] = useState(false);
  const [activeMethodData, setActiveMethodData] = useState(null);
  const confirm2FA =({ cb,
    errorCb,
    finalCb
  }:Callbacks)=> async (code:string) => {
    const body = {
      code,
    };
    try{
      await verify2FAOtp(body);
      toast.success('OTP verified successfully.');
      setIs2FAVerified(true);
      setModeActive(null);
      cb?.();
      return 'true';
    }
    catch (err){
      toast.error(err?.errorMeta?.message)
      errorCb?.(err);
      if(err?.errorMeta?.title === 'INVALID_CODE'){
        return 'ERROR';
      }
      return 'false';
    }
    finally{
      finalCb?.();
    }
  };

  const fetchActive2FAMethod = async () => {
    try {
      const response = await getActive2FAMethod();
      setModeActive(response.authType);
      setActiveMethodData(response);
    } catch (err) {
      toast.error(err?.message);
    }
  };
  const open2FA = async ({cb}:{cb?: () =>void}) => {
    try {
      await validate2FA();
      setIs2FAVerified(true);
      cb?.()
    } catch {
      fetchActive2FAMethod();
    }
  };
  const close2FA = () => {
    setModeActive(null);
  }
  const sendOtp = async() => {
    try{
      const response=await send2FAOtp();
      toast.success(response.message);
    }catch(err){
      if(err.message === 'Send OTP attempts over!'){
        toast.error(`Please retry after ${err.errorMeta.retryAfter}`);
      }
    }
  };
  const values=useMemo(() => ({
    modeActive,
    activeMethodData,
    is2FAVerified,
    fetchActive2FAMethod,
    open2FA,
    confirm2FA,
    close2FA,
    sendOtp
  }),[modeActive,activeMethodData,is2FAVerified])
  return <TwoFAContext.Provider value={values}>{children}</TwoFAContext.Provider>;
};

export default TwoFAProvider;
